export const LIST_LABEL = 'discover_selected';

export const MAX_SPONSORED_PRODUCTS = 12;
